<template>
    <slot :plainValue="plainValue">
        <pre>{{option}}</pre>
    </slot>
</template>
<script>

import isUndefined from '../isUndefined.js';

export default {
    props: {
        option: {
            required:true,
        }
    },
    computed: {
        plainValue() {

            if(this.option._id) {
                return this.option._id;
            }

            const optionValue = this.option.value;
            if(!isUndefined(optionValue)) {
                // If we have a value
                return this.option.value;
            }

            return this.option;
        },
    }
}
</script>